<template>
  <div class="page">
       <el-form
            :model='queryForm'
            ref='form'
            label-width='80px'
            :inline='true'
            size='small'
            class='query-form'
            @submit.native.prevent
        >
            <el-form-item label='用户手机号' label-width="150px">
                <el-input clearable v-model='queryForm.userMobile' size='small' style='width: 200px'
                          placeholder='请输入用户手机号'></el-input>
            </el-form-item>
            <el-form-item  label='上级手机号' label-width="150px">
                <el-input clearable v-model='queryForm.parentMobile' size='small' style='width: 200px'
                          placeholder='请输入用户手机号'></el-input>
            </el-form-item>
            <el-form-item label='队长手机号' label-width="150px">
                <el-input clearable v-model='queryForm.teamMobile' size='small' style='width: 200px'
                          placeholder='请输入用户手机号'></el-input>
            </el-form-item>
          
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getBrandList'>查询
                </el-button>
                <el-button size='small' icon='el-icon-refresh' @click='refreshShopBrandList()'>重置</el-button>
            </el-form-item>
        </el-form>
    <div class="page-content">
           <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-plus'
                        @click='importTemplate()'
                         :loading="btnLoading"
                    >导出
                    </el-button>
                </div>
            </div>   
      <!-- 列表数据 -->
      <el-table
        height='100%'
        :data="shopBrandList"
        row-key="id"
        @selection-change="handleSelectionChange"
        size="small"
        border
        v-loading="loading"
      >
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="userMobile"
          label="用户手机号"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="parentMobile"
          label="上级手机号"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="teamMobile"
          label="团队手机号"
          min-width="10%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="teamYj"
          label="团队业绩"
          min-width="15%"
        >
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="level"
          label="级别"
          min-width="10%"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="realConsumption"
          label="实际消费"
          min-width="10%"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="dividedConsumption"
          label="线下消费"
          min-width="10%"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="monthTime"
          label="月份"
          min-width="10%"
        >
       </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="actualMoney"
          label="实际金额"
          min-width="10%"
        >
       </el-table-column>
        
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="sizeChange"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          background
          :pager-count="7"
        >
        </el-pagination>
      </div>
    </div>
    
  </div>
</template>

<script>
import { Refresh} from '@v2icons/tabler';
import { get, post, deleteFun, upload ,postJson, importTemplate } from '@/utils/request.js';
export default {
   components: {
    Refresh
  },  

    data() {
        return {
            queryForm: {
                 userMobile:'', 
                 parentMobile: '',
                 teamMobile: '',
                 },
            timeRange: [],
            loading: false,
            isSearch: false,
            pageSize: 20,
            currentPage: 1,
            totalNum: 0,
            multipleSelection: [],
            shopBrandList: [],//列表数据
            groupValue: [],
            waitMoney:null,
            btnLoading:false,
        };
    },
    mounted() {
        this.getBrandList();
    },
    methods: {
        importTemplate() {
        this.btnLoading = true;
        
        // 使用 postJson 发送 POST 请求，配置 responseType 为 blob
        postJson(`/user/team/export`, {
                   userMobile:this.queryForm.userMobile,
                   parentMobile:this.queryForm.parentMobile,
                   teamMobile:this.queryForm.teamMobile}, { responseType: 'blob' })
            .then((res) => {
                this.btnLoading = false;
                
                // 检查响应是否为 blob 类型
                if (res.type) {
                    // 文件下载
                    const blob = new Blob([res], {
                        type: 'application/vnd.ms-excel'
                    });
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', '团队业绩数据.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                    
                    this.$message({ 
                        message: '导出成功', 
                        type: 'success' 
                    });
                } else {
                    this.$message.warning('导出失败');
                }
            })
            .catch((err) => {
                this.btnLoading = false;
                this.$message.error('导出失败');
            });
    },
        thousandSeparator(value) {
            if (!value && value !== 0) return '';
                const num = Number(value);
                if (isNaN(num)) return value;

                // 如果大于等于1000，使用千分位格式化
                if (num >= 1000) {
                return num.toLocaleString('en-US');
                }
                return num;
        },
     
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopBrandList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopBrandList = [];
        },
      
        refreshShopBrandList() {
            this.queryForm = {
                 userMobile:'', 
                 parentMobile: '',
                 teamMobile: '',
            };
            this.resetShopBrandList();
            this.getBrandList();
        },
        // 列表数据请求
        getBrandList() {
                //正则校验手机号
                const phoneRegex = /^1[3-9]\d{9}$/;
                if (this.queryForm.userMobile && !phoneRegex.test(this.queryForm.userMobile)) {
                    this.$message({
                        message: '请输入正确的用户手机号',
                        type: 'warning',
                        duration: 2000
                    });
                    return;
                }
                if (this.queryForm.parentMobile && !phoneRegex.test(this.queryForm.parentMobile)) {
                    this.$message({
                        message: '请输入正确的上级手机号',
                        type: 'warning',
                        duration: 2000
                    });
                    return;
                }
                if (this.queryForm.teamMobile && !phoneRegex.test(this.queryForm.teamMobile)) {
                    this.$message({
                        message: '请输入正确的队长手机号',
                        type: 'warning',
                        duration: 2000
                    });
                    return;
                }
                this.loading = true;
                postJson(`/user/team/queryList`, {
                    ...this.queryForm,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                }).then((res) => {
                    this.loading = false;
                    if(res.success){
                        this.shopBrandList = res.list.list
                        this.totalNum = res.list.total
                    }else{
                       this.$message({
                           message: res.msg,
                           type: 'error',
                            duration: 2000
                       });
                    }
                });  
             },
        resetQueryFrom() {
            this.getBrandList();
        },
        
        handleSelectionChange(value) {
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getBrandList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getBrandList();
        },
    }
};
</script>

<style lang="scss" scoped>



::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 178px;
    height: 178px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.logo-img {
    margin-left: 50%;
    transform: translate(-50%, 0);
}
.count{
    margin-right:1.5625vw;
}
</style>
